<!-- Ported from the Polaris kit: src/components/ui/message/Message.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { Primitive } from 'reka-ui';
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
  align: { type: String, required: false, default: 'start' },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false, default: 'div' },
});
</script>

<template>
  <Primitive
    data-slot="message"
    :data-align="align"
    :as="as"
    :as-child="asChild"
    :class="
      cn(
        'type-polaris-body gap-2 group/message relative flex w-full min-w-0 data-[align=end]:flex-row-reverse',
        props.class
      )
    "
  >
    <slot />
  </Primitive>
</template>
